/**
 * @GestionalePD admin sidebar variables
 */
import SvgColor from '../../../components/svg-color';

// custom icon variable
const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

// Admin sidebar default variables
const navConfig = [
  {
    title: 'dashboard',
    path: '/admin/dashboard',
    icon: icon('ic_dashboard'),
    auth: false,
  },
  {
    title: 'campagne',
    path: '/admin/campaigns',
    icon: icon('ic_campaign'),
    auth: false,
  },
  {
    title: 'organizzazione',
    path: '/admin/organization',
    icon: icon('ic_organization'),
    auth: false,
  },
  {
    title: 'anagrafiche utenti',
    path: '/admin/users',
    icon: icon('ic_personaldata'),
    auth: false,
  },
  {
    title: 'anagrafiche tessere',
    path: '/admin/cards',
    icon: icon('ic_cardsdata'),
    auth: false,
  },
  {
    title: 'eventi',
    path: '/admin/events',
    icon: icon('ic_calendar'),
    auth: false,
  },
  {
    title: 'bonifici cumulativi',
    path: '/admin/bank-transfers',
    icon: icon('ic_bank'),
    auth: false,
  },
  {
    title: 'riconciliazione bonifici',
    path: '/admin/bankpayment',
    icon: icon('ic_bank'),
    auth: false,
  },
  {
    title: 'newsletter',
    icon: icon('ic_newsletter'),
    auth: 'can_manage_newsletters',
    children: [
      { title: 'gestione', path: '/admin/newsletter', auth: 'can_manage_newsletters' },
      { title: 'report', path: '/admin/newsletter/report', auth: 'can_manage_newsletters' },
    ],
  },
  {
    title: 'dati utenti',
    path: '/admin/userdata',
    icon: icon('ic_userdata'),
    auth: 'app_download_db',
  },
  {
    title: 'anagrafica comuni',
    path: '/admin/cityfiscalcode',
    icon: icon('ic_cityfiscalcode'),
    auth: 'app_auth',
  },
  {
    title: 'importazione',
    path: '/admin/import',
    icon: icon('ic_import'),
    auth: 'can_import',
  },
  {
    title: 'filtri utenti',
    path: '/admin/filters',
    icon: icon('ic_filter'),
    auth: 'can_manage_filters',
  },
  // {
  //   title: 'calendario',
  //   path: '/admin/calendar',
  //   icon: icon('ic_calendar'),
  // },
  // {
  //   title: 'dati elettorali',
  //   path: '/admin/electoralData',
  //   icon: icon('ic_chart'),
  // },
  // {
  //   title: 'questionari',
  //   path: '/admin/surveys',
  //   icon: icon('ic_vote'),
  // },
  // {
  //   title: 'documenti',
  //   path: '/admin/documents',
  //   icon: icon('ic_documents'),
  // },
  // {
  //   title: 'report',
  //   path: '/admin/report',
  //   icon: icon('ic_flag'),
  // },
];

export default navConfig;
